export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11199.6c1c4892.jpg";